import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

const ProductSkeleton = (props) => {
	return (
		<React.Fragment>
			<SkeletonTheme baseColor="#f7fafc" highlightColor="#eff1ff">
				<div className='mainProductContainer' style={{ display: "flex", position: "relative", width: "100%", height: "100%" }}>
					<div className='selectableSideMenuProductCard' style={{ width: "100%", height: "100%" }}>
						<div className='productCard'>
							<div className='imageAndActionContainer'>
								<div className='imageWrapper'>
									<Skeleton height={160} />
								</div>
							</div>
							<div className='productInfoContainer'>
								<div className='productTitleWrapper'>
									<Skeleton height={20} />
								</div>
								<div className='productSkuWrapper'><Skeleton height={15} /></div>
								<div className='productCardFooter'>
									<div className='productPriceContainer'>
										<Skeleton height={10} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</SkeletonTheme>
		</React.Fragment>
	);
}

export default ProductSkeleton;